import { isSuperUser } from "./isSuperUser";
import { UseLivlyLeaseUser } from "./LivlyUserProvider";

/** Whether the signed-in user is a super user (the `isSuperUser(UseLivlyLeaseUser())` pattern). */
export function useIsSuperUser(): boolean {
  return isSuperUser(UseLivlyLeaseUser());
}
